module.exports = __webpack_public_path__ + "static/img/map.06c48f99.png";